import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Link, Outlet, Route, RouterProvider } from 'react-router-dom';
import CartContextProvider from './Contexts/CartContext';
import Checkout from './pages/Checkout';
import Orders from './pages/db/Orders';
import Order, { dataLoader } from './pages/Order';

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path='/' element={<Root />}>
        <Route index element={<Order />} loader={dataLoader} />
        <Route path='/checkout' element={<Checkout />} />
        <Route path='/order' element={<Order />} loader={dataLoader} />

        <Route path='/sm-dashboard' element={<Orders />} />
      </Route>
    )
  );

  return (
    <div className="App">
      <CartContextProvider>
        <RouterProvider router={router} />
      </CartContextProvider>
    </div>
  );
}

export default App;

const Root = () => {
  return <>
    <div>
      <Link to="/">Commander</Link>
      <Link to="/checkout">Checkout</Link>
    </div>

    <Outlet />
  </>
}